import { contactCard } from './contactCard';

export const titleOfficerContactCard = contactCard(
  'additionalContacts.titleOfficer',
  'titleOfficer',
);
